import { ProductRouteNotFound } from '@/shared/comunicaciones-producto/product-route-not-found';

export default ProductRouteNotFound;
